import { ChartService } from "./historical-chart.service";
import { type StablecoinLatestDO } from "../data/pie-chart.data";
import { type BubbleDO } from "../data/bubble.data";

export class BubbleChartService {
  constructor(private chartService: ChartService) { }

  async loadBubbleDefiTradfiTVL(): Promise<BubbleDO> {
    return this.chartService.load("bubble_defi_vs_tradfi_tvl");
  }

  async loadStablecoinVsBanks(): Promise<StablecoinLatestDO> {
    return this.chartService.load(`/latest/stablecoins`);
  }
}
